<template>
    <ul v-if="keyWords.length > 1" class="row list-unstyled px-1 mb-0" aria-label="Attributs de l'offre">
        <li v-for="(keyword, index) in keyWords" :key="index" class="col-auto px-0 pb-1">
            <status-tag
                v-if="keyword"
                :key="index"
                version="reminder"
                :label="keyword"
            />
        </li>
    </ul>
    <div v-else class="row px-1 mb-0" aria-label="Attribut de l'offre">
        <div v-for="(keyword, index) in keyWords" :key="index" class="col-auto px-0 pb-1">
            <status-tag
                v-if="keyword"
                :key="index"
                version="reminder"
                :label="keyword"
            />
        </div>
    </div>
</template>

<script>

import StatusTag from "../../../../../common/components/ob1/StatusTag.vue";

export default {
    name: "OffertagsList",
    components: {StatusTag},
    props: {
        keyWords: {
            type: Array,
            required: true
        },
    }
}
</script>

<style scoped lang="scss">

</style>
